module.exports = __webpack_public_path__ + "static/img/manual_ja_21.a6e5146.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/ja/manual_ja_21.png
// module id = YnTr
// module chunks = 4